import React from 'react'

import { AppearingWrapper, SubsectionTitle } from 'Components/Blocks'
import { Column, Text } from 'Components/UI'

import { useResponsiveLayout } from 'Hooks'

function WelcomeSectionTitle() {
  const { isDesktop } = useResponsiveLayout()

  return (
    <Column alignCenter fullWidth maxWidth="1050px">
      <AppearingWrapper centered kind="expand">
        <SubsectionTitle
          centered
          paragraph="Emajin Golf is Australia's largest golf and business networking community, connecting business owners, senior leaders and C-suite executives through a shared passion for the golf. Our story has been featured in:"
          subtitle={
            <>
              We provide a platform for building&nbsp;
              <Text
                as="span"
                bold
                screen24={!isDesktop}
                screen28={isDesktop}
                success
              >
                meaningful relationships
              </Text>
              &nbsp;and unlocking
              <br />
              <Text
                as="span"
                bold
                screen24={!isDesktop}
                screen28={isDesktop}
                success
              >
                new opportunities
              </Text>
              &nbsp;in a relaxed and effective setting.
            </>
          }
          title="Welcome to Emajin Golf"
        />
      </AppearingWrapper>
    </Column>
  )
}

export default WelcomeSectionTitle
